import { Close } from "@mui/icons-material";
import { Button, IconButton, Modal, Paper, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, RHFTextField } from "../../../components/hook-form";
import { CLOSE_EDIT_LOOKINGFOR } from "../../../redux/types";
import RHFSelectField from "../../../components/hook-form/RHFSelect";
import { updateProfile } from "../../../redux/actions/profileActions";

const EditLookingFor = () => {
  const { openLookingFor: open } = useSelector((state) => state.ModalsControl);

  const lookingForSchema = Yup.object().shape({
    mbti: Yup.string(),
    interestedIn: Yup.string(),
    description: Yup.string(),
    ageMin: Yup.number(),
    ageMax: Yup.number(),
  });

  const defaultValues = {
    mbti: "",
    ageMin: 18,
    ageMax: 18,
    interestedIn: "",
    description: "",

    // remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(lookingForSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = (values) => {
    console.log(values);

    dispatch(updateProfile({ partner: { ...values } }));
    dispatch({ type: CLOSE_EDIT_LOOKINGFOR });
  };
  const dispatch = useDispatch();
  return (
    <Modal
      className="grid place-items-center overflow-scroll"
      open={open}
      onClose={() => dispatch({ type: CLOSE_EDIT_LOOKINGFOR })}>
      <Paper elevation={8} className="!bg-slate-100 p-2 w-[90%] my-4">
        <IconButton
          className="absolute top-0 left-4"
          onClick={() => dispatch({ type: CLOSE_EDIT_LOOKINGFOR })}>
          <Close />
        </IconButton>

        <FormProvider
          methods={methods}
          classes=" shadow-lg border-slate-100 rounded-lg p-6 mt-4   bg-white grid place-items"
          onSubmit={handleSubmit(onSubmit)}>
          <div className="flex items-center child:mr-2 mb-4">
            <div className="child:mr-2">
              <label htmlFor="looking">I am</label>
              <select
                {...register("interestedIn")}
                className="bg-slate-100 p-2"
                name="interestedIn"
                id="looking">
                <option value=""></option>
                <option value="looking for a woman">Looking for a woman</option>
                <option value="looking for a man">Looking for a man</option>
              </select>
            </div>
          </div>
          <div className="child:mb-5">
            <label htmlFor="ageMin">Between ages</label>
            <div className="flex items-center justify-between space-x-2 mt-2">
              <input
                type="number"
                {...register("ageMin")}
                name="ageMin"
                id="ageMin"
                defaultValue={18}
                className=" rounded-sm p-2 w-full focus:outline-blue-400 focus:bg-white focus:border-transparent   focus:shadow-blue-400 border bg-slate-50 outline-none"
                min={18}
              />
              <label htmlFor="ageMax">and</label>

              <input
                type="number"
                {...register("ageMax")}
                name="ageMax"
                id="ageMax"
                defaultValue={30}
                className=" rounded-sm p-2 w-full focus:outline-blue-400 focus:bg-white focus:border-transparent   focus:shadow-blue-400 border bg-slate-50 outline-none"
                max={60}
                min={18}
              />
            </div>
          </div>
          <div>
            <RHFSelectField label="with an mbti of" name="mbti">
              <option value=""></option>
              <option value="INTJ">INTJ</option>
              <option value="INTP">INTP</option>
              <option value="ENTP">ENTP</option>
              <option value="ENTJ">ENTJ</option>

              <option value="ENFJ">ENFJ</option>
              <option value="ENFP">ENFP</option>
              <option value="INFJ">INFJ</option>
              <option value="INFP">INFP</option>

              <option value="ISFJ">ISFJ</option>
              <option value="ISFP">ISFP</option>
              <option value="ESFP">ESFP</option>
              <option value="ESFJ">ESFJ</option>

              <option value="ISTJ">ISTJ</option>
              <option value="ISTP">ISTP</option>
              <option value="ESTP">ESTP</option>
              <option value="ESTJ">ESTJ</option>
            </RHFSelectField>
          </div>

          <div className="mb-4">
            <textarea
              name="description"
              {...register("description")}
              className="bg-slate-100 w-full h-[8rem] rounded-md shadow shadow-black/10 p-4 resize-none"
              placeholder="few words about your ideal partner"
              id=""></textarea>
          </div>
          <Button type="submit" variant="contained" className="!bg-rose-500">
            save
          </Button>
        </FormProvider>
      </Paper>
    </Modal>
  );
};

export default EditLookingFor;
